import { t } from 'i18next'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { DeleteIcon } from 'src/components/shared/ui/Icons'
import LexnetIconButton from 'src/components/shared/ui/form/fields/LexnetIconButton'
import { useAlertContext } from 'src/contexts/AlertContext'

type Props = {
  clear: () => void
  firstDialogMessage: string
  disabled?: boolean
}

export default function RemoveInfoButton({
  disabled,
  clear,
  firstDialogMessage
}: Props): JSX.Element {
  const { addAlert } = useAlertContext()

  return (
    <LexnetIconButton
      disabled={disabled}
      title={t('actions.clean_seccion')}
      handleClick={() => {
        addAlert({
          message: firstDialogMessage,
          type: AlertType.INFO,
          action: async () => {
            await clear()
            addAlert({
              message: t('dialog.message.removed_info_success'),
              type: AlertType.SUCCESS
            })
          }
        })
      }}
    >
      <DeleteIcon />
    </LexnetIconButton>
  )
}
